import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LocationHeaderComponent } from './header/location-header.component';
import { LocationFooterComponent } from './footer/location-footer.component';

@Component({
  selector: 'out-locations',
  imports: [
    CommonModule,
    RouterOutlet,
    LocationHeaderComponent,
    LocationFooterComponent,
  ],
  templateUrl: './locations.component.html',
  styleUrl: './locations.component.scss',
})
export class LocationsComponent {
  @Input() logoSrc = '/assets/images/out-horizontal-logo.svg';
  @Input() sideLogoSrc = '/assets/images/sidebar-logo.svg';
}
